"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_GROUP = void 0;
exports.NO_GROUP = "NO_GROUP";
//# sourceMappingURL=types.js.map